function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5933 14.9812L29.3393 25.217C30.2202 25.9245 30.2202 27.0685 29.3393 27.7684L27.2212 29.4694C26.3402 30.1769 24.9157 30.1769 24.044 29.4694L15.0094 22.214L5.9747 29.4694C5.09372 30.1769 3.66917 30.1769 2.79756 29.4694L0.660731 27.776C-0.220244 27.0685 -0.220244 25.9245 0.660731 25.2245L13.4067 14.9887C14.2877 14.2737 15.7123 14.2737 16.5933 14.9812ZM13.4067 0.530607L0.66073 10.7664C-0.220245 11.4739 -0.220244 12.6179 0.66073 13.3179L2.77882 15.0188C3.65979 15.7263 5.08435 15.7263 5.95595 15.0188L14.9906 7.76342L24.0253 15.0188C24.9063 15.7263 26.3308 15.7263 27.2024 15.0188L29.3205 13.3179C30.2015 12.6104 30.2015 11.4664 29.3205 10.7664L16.5745 0.530606C15.7123 -0.176871 14.2877 -0.176871 13.4067 0.530607Z",
  fill: "#fff"
});

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.68ce7906.svg";
export { ForwardRef as ReactComponent };